var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.781 5.46936C20.8508 5.53903 20.9062 5.6218 20.944 5.71291C20.9818 5.80403 21.0013 5.90171 21.0013 6.00036C21.0013 6.09902 20.9818 6.1967 20.944 6.28781C20.9062 6.37893 20.8508 6.4617 20.781 6.53136L10.281 17.0314C10.2113 17.1012 10.1285 17.1566 10.0374 17.1944C9.9463 17.2322 9.84862 17.2517 9.74997 17.2517C9.65132 17.2517 9.55364 17.2322 9.46252 17.1944C9.3714 17.1566 9.28864 17.1012 9.21897 17.0314L3.96897 11.7814C3.82814 11.6405 3.74902 11.4495 3.74902 11.2504C3.74902 11.0512 3.82814 10.8602 3.96897 10.7194C4.1098 10.5785 4.30081 10.4994 4.49997 10.4994C4.69913 10.4994 4.89014 10.5785 5.03097 10.7194L9.74997 15.4399L19.719 5.46936C19.7886 5.39952 19.8714 5.34411 19.9625 5.3063C20.0536 5.26849 20.1513 5.24902 20.25 5.24902C20.3486 5.24902 20.4463 5.26849 20.5374 5.3063C20.6285 5.34411 20.7113 5.39952 20.781 5.46936Z",
    fill: "#1C2026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.b769fba2240296f65b0b2a2488f15f62.svg";
export { ForwardRef as ReactComponent };